import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const options = [
  { label: 'Nenhum', value: 'by_none' },
  { label: 'Por tipo de cartão', value: 'by_card_type' },
]

export const strategy = optionsToStrategy(options)
